import {
  Box,
  BoxProps,
  Flex,
  FlexProps,
  Heading,
  HeadingProps,
} from "@chakra-ui/react";

export const PANEL_PADDING = 4;

export function PanelHeader(props: FlexProps) {
  return (
    <Flex
      borderBottomWidth={1}
      px={PANEL_PADDING}
      py={3}
      alignItems="center"
      {...props}
    />
  );
}

export function PanelHeading(props: HeadingProps) {
  return <Heading size="sm" color="magenta.veryDark" {...props} />;
}

export function PanelBody(props: BoxProps) {
  return <Box p={PANEL_PADDING} {...props} />;
}

export function PanelFooter(props: FlexProps) {
  return (
    <Flex
      borderTopWidth={1}
      px={PANEL_PADDING}
      py={3}
      alignItems="center"
      justifyContent="flex-end"
      mt="auto"
      {...props}
    />
  );
}

export type PanelProps = BoxProps;

export default function Panel(props: PanelProps) {
  return (
    <Flex
      borderWidth={1}
      borderRadius="md"
      boxShadow="0 1px 2px rgba(0,0,0,.025)"
      flexFlow="column"
      {...props}
    />
  );
}
